var version = {
    "name":      "dativery",
    "buildDateCode": "20260820-102958",
    "buildDate": "Thu Aug 20 2026 10:29:58 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260820-102958",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;